import { CardTitle } from "react-migration/components/CardTitle";

export function DemographicsSelectionTitle() {
  return <CardTitle>Demographics</CardTitle>;
}
